module.exports = __webpack_public_path__ + "static/1-c12dd23d69602d7fbc2fed348d582581.png";